module.exports = "/build/web/svg/plus.af1830e56e3c73fbe831d2ca7e833c51.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/plus.svg
// module id = 178
// module chunks = 24